import React, { memo } from 'react';
import { getCompactNumber } from 'utils/formatting';
import { CardView } from 'design-system';
import CardRowContainer from 'design-system/CardRowContainer';
import AboutInfoRow from './AboutInfoRow';
import SectionHeader from './SectionHeader';
import CollapsibleSection from './CollapsibleSection';
const StockAboutSection = ({ ceo, sector, website, employees, description, headquarters, scrollViewRef, }) => (<>
    <SectionHeader title="About"/>
    <CardView noMarginTop noMarginBottom>
      <CardRowContainer>
        <AboutInfoRow tableSpacing title="CEO" info={ceo}/>
        <AboutInfoRow tableSpacing title="Employees" info={employees ? getCompactNumber(employees, 1) : undefined}/>
        <AboutInfoRow tableSpacing title="Sector" info={sector}/>
        <AboutInfoRow tableSpacing title="Company HQ" info={headquarters}/>
        <AboutInfoRow tableSpacing title="Website" info={website} isLink/>
      </CardRowContainer>
    </CardView>
    {!!description && (<>
        <SectionHeader title="Description"/>
        <CardView noMarginTop noMarginBottom>
          <CollapsibleSection text={description} scrollViewRef={scrollViewRef}/>
        </CardView>
      </>)}
  </>);
export default memo(StockAboutSection);
